import { GetOfficeSuppliesApiParameter } from "@GeriMed/Services/OfficeSuppliesService";
import { OfficeSuppliesState } from "@GeriMed/Store/Data/OfficeSupplies/OfficeSuppliesState";
import { CustomerDisplayProductCollection } from "@GeriMed/Type/ApiModelsExt";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: OfficeSuppliesState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const reducer = {
    "Data/OfficeSupplies/BeginLoadOfficeSupplies": (
        draft: Draft<OfficeSuppliesState>,
        action: { parameter: GetOfficeSuppliesApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/OfficeSupplies/CompleteLoadOfficeSupplies": (
        draft: Draft<OfficeSuppliesState>,
        action: { parameter: GetOfficeSuppliesApiParameter; collection: CustomerDisplayProductCollection },
    ) => {
        setDataViewLoaded(
            draft,
            action.parameter,
            action.collection,
            collection => action.collection.productList,
        );
    },
    "Data/OfficeSupplies/Reset": () => {
        return initialState;
    },
};

const officeSuppliesreducer = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).dataOfficeSupplies = officeSuppliesreducer;
